import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAuthenticatedUser, IAuthenticationPayloadRequest, IAuthenticationState, IChangePassword } from "./types";

const initialState: IAuthenticationState = {
  isLoading: false,
};

export const authenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    authenticationRequest: (state, action: PayloadAction<IAuthenticationPayloadRequest>) => {
      state.isLoading = true;
      state.error = undefined;
    },
    authenticationSuccess: (state,action: PayloadAction<IAuthenticatedUser>) => {
      state.isLoading = false;
      state.error = undefined;
      state.user = action.payload;
    },
    authenticationFailure: (state, action: PayloadAction<ISystemErrors>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    startChangePassword: (state) => {
      state.draftChangePassword = {
        password: "",
        newPassword: "",
        confirmationPassword: "",
      };
    },
    stopChangePassword: (state) => {
      state.draftChangePassword = undefined;
    },
    changePasswordDraftUpdate: (state, action: PayloadAction<IChangePassword>) => {
      state.draftChangePassword = action.payload;
    },
    changePasswordSaveRequest: (state, action: PayloadAction<IChangePassword>) => {
      if (state.draftChangePassword) {
        state.draftChangePassword.isSaving = true;
        state.draftChangePassword.error = undefined;
      }
    },
    changePasswordSaveSucess: (state, action: PayloadAction<IChangePassword>) => {
      state.draftChangePassword = undefined;
      state.error = undefined;
    },
    changePasswordSaveFailure: (state, action: PayloadAction<ISystemErrors>) => {
      if (state.draftChangePassword) {
        state.draftChangePassword.isSaving = false;
        state.draftChangePassword.error = action.payload;
      }
    },
    profileUserRequest: (state) => {
      state.isLoading = true;
      state.error = undefined;
    },
    profileUserSuccess: (state, action: PayloadAction<IAuthenticatedUser>) => {
      state.user = action.payload;
      state.isLoading = false;
    },
    profileUserFailure: (state, action: PayloadAction<ISystemErrors>) =>{
      state.isLoading = false;
      // state.error = action.payload;
      if(state.user) {
        state.user.error = action.payload;
      }
    }
  },
});

// Action creators are generated for each case reducer function
export const {
  authenticationRequest,
  authenticationSuccess,
  authenticationFailure,
  startChangePassword,
  stopChangePassword,
  changePasswordSaveRequest,
  changePasswordSaveSucess,
  changePasswordSaveFailure,
  changePasswordDraftUpdate,
  profileUserRequest,
  profileUserSuccess,
  profileUserFailure,
} = authenticationSlice.actions;

export default authenticationSlice.reducer;
